<template>
  <router-view />
</template>

<script>
  export default {
    name: 'BaseLocaleRouter'
  }
</script>
